import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import { useState } from 'react';
// import store from '../store/redux-store/root_store';
import { getToken } from '../base/utils';
import { initialStateModel } from '../base/models/meetModal';
import { useDispatch, useSelector } from 'react-redux';
import { GuestPage } from '../guestPage/index';
import { useLocation } from "react-router-dom";
import { Joining } from '../joining/index';
import {videoCallService} from '../base/service/videoCallService';
import { MeetServices } from '../base/service/apiServices';
import { meetActions } from '../store/slices/meet_slice/meetslice';
import { getUserInfo, throwLoading, updateVirtualBGRedux } from '../base/video_common';
import { JoinMeetingScreen } from '../components/joinMeetingScreen';
import store from "../store/redux-store/root_store"
import WebChatScreen from '../components/webChatScreen';
import Check from '../components/check';
import { Waiting } from '../waiting';
import { JoinMeetingThankspage } from '../components/ThankYouspage';
import { GetItemFromStorage, SetItemInStorage } from '../custom_hooks/useStorage';
import axios from 'axios';
// import { JoinMeetingScreenComponent } from '../components/joinMeetingScreen';

export const CommonContainer = () => {
  let { socketData } = store.getState().storeVideo;
  const [mount, setMount] = useState<boolean>(false);
  const [connectionStatus, setConnection] = useState<boolean>(false);
  const getCookie: any = getToken();
  const [participant, setParticipant] = useState<string>
    (getCookie["ssoToken"] ? "registered" : getCookie["guestToken"] ? "guest" : "");
  let history:any = useLocation();
  let dispatch:any=useDispatch();
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const allReducer:initialStateModel = useSelector((state: initialStateModel) => state);
  
  const { meetingDetails } = videoMeetState.meetingReducer;
  const tokens = getCookie["guestToken"] ? getCookie["guestToken"] : "";
  const searchParams = useMemo(() => {
    const searchParams = new URLSearchParams(history?.search);
    
    return searchParams;
  }, [history?.search]);

  useEffect(() => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('createConnection');
  }, [])

  useLayoutEffect(() => {
    const meeting = history?.pathname.slice(1);
    let idx:any=meeting.lastIndexOf("/");
    console.log(idx,"idx==");
    
    const meetingid=meeting.slice(idx+1);
    const storagemeetingID: any = GetItemFromStorage('meetingId') || '';
    const isLoggedIn: string = GetItemFromStorage('isLoggedIn') || '';
    const createConnectionStorage: string = GetItemFromStorage('createConnection') || '';
    const { meetingDetails } = videoMeetState.meetingReducer;
    if (mount && meetingid && tokens && storagemeetingID && meetingDetails.invite_url &&
      storagemeetingID === meetingid && isLoggedIn) {
      SetItemInStorage('authorization', tokens || '');
      const token = GetItemFromStorage('authorization') || '';
      if (token) {
        if (isLoggedIn && isLoggedIn !== "null" && !connectionStatus && !createConnectionStorage) {
          SetItemInStorage('createConnection', "1");
          new videoCallService(dispatch).createConnection(meetingDetails.uuid,false,"");
          setConnection(true);
        }
      }

    } else if (tokens && !mount && (!isLoggedIn || isLoggedIn === "null") && !createConnectionStorage) {
      SetItemInStorage('authorization', tokens);
      if (getCookie["guestToken"]) {
        setMount(true);
      }
      if (storagemeetingID !== meetingid) {
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('guest');
        localStorage.removeItem('USER_DETAILS');
        localStorage.removeItem('authorization');
        localStorage.removeItem('deviceid');
        localStorage.removeItem('chat');
        document.cookie = "guestToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=";
        window.location.reload();
      }
      MeetServices.get(meetingid,`get_agent_meeting`).then((res:any)=>{
        dispatch(meetActions.updateMeetDetails({meetingDetails:res?.result}))
      })
      .catch((err:any)=>{
            console.log("err",err)
      })
      SetItemInStorage('meetingId', meetingid);
      if (videoMeetState.meetingReducer.meetingDetails.is_custom_password && (!isLoggedIn || isLoggedIn === "null")) {
        throwLoading(false);
        
        console.log("socket loading 03");
      }
    } else if (!createConnectionStorage && !mount && (!isLoggedIn || isLoggedIn === "null")) {
      SetItemInStorage('meetingId', meetingid);
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('createConnection');
      throwLoading(false);
      
      console.log("socket loading 04");
      // dispatch(meetActions.updateSocketLoading({ isLoading: false }));
    }

  }, [mount, history, searchParams, videoMeetState.meetingReducer.meetingDetails,
    tokens, videoMeetState.loginReducer]);

  const timerForConnection = () => {
    //setConnectionPage(false);
  };

  const { isLoading, isError, thankYou, connstatus, isFailure
    , sockmeetDetails, currdeviceinfo,iceState }:any = store.getState().meetingReducer;
  useEffect(() => {
    let connstatus:any = store.getState().meetingReducer;
    
    console.log("common containter===");
    if (socketData.length > 1) {
      // setConnectionPage(true);
      setTimeout(timerForConnection, 5000);
    }

    return () => {
    };
  }, [socketData,JSON.stringify(isError)]);

  const joinParticipant = (participant: string) => {
    setParticipant(participant);
  };



  return (
  <React.Fragment>

      {(connstatus === "queuewaiting" || connstatus ==="connected")  && !currdeviceinfo.isHost && !meetingDetails.is_participant_waiting_room && !sockmeetDetails.isHostjoined &&
        <div className="centerLoader"><Waiting /></div>}
           {(connstatus === "queuewaiting")  && !currdeviceinfo.isHost && !meetingDetails.is_participant_waiting_room && sockmeetDetails.isHostjoined &&
        <div className="centerLoader"><Waiting /></div>}
      {(connstatus === "join_init") && !iceState && (currdeviceinfo.isHost || (!currdeviceinfo.isHost && !meetingDetails.is_participant_waiting_room)) &&
        <div className="centerLoader"><Joining /></div>}
      {(connstatus === "") && <>
        {(isError.message === "Something went wrong!!!" || isError.message === "" || isError.message ==="Not_valid_participants" || isError.message === "Meeting not found") ? <GuestPage participantType={participant}></GuestPage>: isError.message === "Meeting Link is expired" ?  <JoinMeetingThankspage  type ="expired"/>  : null}
        </>
      }
      {(thankYou || isFailure) && <JoinMeetingThankspage  type ="end"/>}
    
               {sockmeetDetails.isParticipantjoinbefhost && !thankYou && ((connstatus === "connected" && sockmeetDetails.isHostjoined && !currdeviceinfo.isHost)) &&
        !currdeviceinfo.isHost &&
        <><JoinMeetingScreen /></>
      }
    </React.Fragment>

  );
};
